var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconVideo = function SvgIconVideo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2415 0.646969C20.143 0.609148 20.0483 0.590158 19.9573 0.590158C19.7527 0.590158 19.5824 0.662296 19.4459 0.806173L14.8652 5.37554V3.50011C14.8652 2.59827 14.545 1.82737 13.9047 1.18701C13.2643 0.546724 12.4935 0.226562 11.5916 0.226562H3.58984C2.6882 0.226562 1.91713 0.546724 1.27673 1.18701C0.636568 1.82737 0.316406 2.59827 0.316406 3.50011V11.502C0.316406 12.4038 0.636568 13.1746 1.27677 13.8149C1.91717 14.4553 2.68824 14.7754 3.58988 14.7754H11.5917C12.4936 14.7754 13.2644 14.4553 13.9048 13.8149C14.5451 13.1746 14.8653 12.4038 14.8653 11.502V9.61507L19.4459 14.1958C19.5825 14.3396 19.7528 14.4117 19.9574 14.4117C20.0484 14.4117 20.1431 14.3928 20.2416 14.355C20.5373 14.2262 20.6849 14.0027 20.6849 13.6844V1.31775C20.6848 0.999337 20.5372 0.775837 20.2415 0.646969Z",
    fill: "#111111"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconVideo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-video.7b996bed.svg";
export { ForwardRef as ReactComponent };